import { IsNumber, IsString, IsUUID } from 'class-validator';

export class StateDto {
  @IsUUID()
  deviceId: string;

  @IsUUID()
  id: string;

  @IsNumber()
  kw: number;

  @IsNumber()
  maxAgeSeconds: number;

  @IsString()
  modDate: string;

  @IsString()
  soc: number;

  @IsString()
  stateInfo: string;
}
